import React from "react";

const CustomSelect = ({
                          title,
                          options = [],
                          value = "",
                          onChange,
                          className = "",
                          name
                      }) => {

    const normalizeOption = (option) => {

        if (typeof option === "string" || typeof option === "number") {
            return {
                value: String(option),
                label: String(option)
            };
        }

        return {
            value: String(option.value),
            label: option.label ?? String(option.value)
        };

    };

    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            <select
                name={name}
                value={value != null ? String(value) : ""}
                onChange={onChange}
                className="border-2 border-gray-200 rounded-md w-full py-3 px-5 focus:outline-none focus:ring"
            >
                <option value="" disabled>
                    {title}
                </option>

                {options.map((option, index) => {

                    const normalized = normalizeOption(option);

                    return (
                        <option
                            key={normalized.value ?? index}
                            value={normalized.value}
                        >
                            {normalized.label}
                        </option>
                    );

                })}
            </select>
        </div>
    );
};

export default CustomSelect;